import { addDays, endOfMonth, endOfWeek, format, startOfMonth, startOfWeek, startOfYear, subDays } from 'date-fns';

import { parseDate } from './parsing';

export const getToday = (): string => format(new Date(), 'yyyy-MM-dd');

export const getTomorrow = (): string => format(addDays(new Date(), 1), 'yyyy-MM-dd');

export const getYesterday = (): string => format(subDays(new Date(), 1), 'yyyy-MM-dd');

export const getYear = (date: string): number => parseDate(date).getFullYear();

// Returns 1-based month (January = 1)
export const getMonth = (date: string): number => parseDate(date).getMonth() + 1;

export const getDayOfMonth = (date: string): number => parseDate(date).getDate();

// Returns ISO day of week: Monday = 1, Sunday = 7
export const getDayOfWeek = (date: string): number => {
  const day = parseDate(date).getDay();

  return day === 0 ? 7 : day;
};

export const getBeginningOfWeek = (date: string): string =>
  format(startOfWeek(parseDate(date), { weekStartsOn: 1 }), 'yyyy-MM-dd');

export const getEndOfWeek = (date: string): string => format(endOfWeek(parseDate(date), { weekStartsOn: 1 }), 'yyyy-MM-dd');

export const getBeginningOfMonth = (date: string): string => format(startOfMonth(parseDate(date)), 'yyyy-MM-dd');

export const getBeginningOfYear = (date: string): string => format(startOfYear(parseDate(date)), 'yyyy-MM-dd');

export const getEndOfMonth = (date: string): string => format(endOfMonth(parseDate(date)), 'yyyy-MM-dd');
